module.exports = __webpack_public_path__ + "img/image13.06cf72c9.jpg";